
define('text!templates/components/reseller_product_modal/reseller_products.html',[],function () { return '<div class="list-container">\n\n</div>';});

